/** @file The files of a bundle (manifest aside): canonical JSON puppet and clips, PNG sheets. */
import { canonicalJson } from '@zilo/pose3d-export/hash/canonicalJson';
import type { ExportBundle } from '@zilo/pose3d-export/types/bundle';
import type { ExportDeps } from '@zilo/pose3d-export/types/exportDeps';

/**
 * `puppet.pose3d.json`, `clips/<name>.json` (canonical JSON strings) and `sheets/<name>.png`: encoded through
 * `deps.encodePng` when the sheet has pixels, else its `png` bytes when it has them; other sheets have no file.
 */
export async function bundleFiles(bundle: Omit<ExportBundle, 'manifest'>, deps: Pick<ExportDeps, 'encodePng'>): Promise<Record<string, Uint8Array | string>> {
  const files: Record<string, Uint8Array | string> = { 'puppet.pose3d.json': canonicalJson(bundle.puppet) };
  for (const [name, clip] of Object.entries(bundle.clips)) files[`clips/${name}.json`] = canonicalJson(clip);
  for (const [name, sheet] of Object.entries(bundle.sheets)) {
    const path = `sheets/${name}.png`;
    if (sheet.pixels !== undefined && deps.encodePng !== undefined) files[path] = await deps.encodePng(sheet.pixels);
    else if (sheet.png !== undefined) files[path] = sheet.png;
  }
  return files;
}
